// Product-card cart button. Wraps a native product form (POST to the cart add route) so it works
// without JavaScript; with Standard Actions available it adds the variant on-page and opens the cart drawer.
class SQuickAdd extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.button = this.querySelector('button[type="submit"]');
    this.status = this.querySelector('[data-quick-add-status]');
    if (!this.form || !this.button) return;
    this.onSubmit = (event) => this.submit(event);
    this.form.addEventListener('submit', this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit);
  }

  async submit(event) {
    if (!window.Shopify?.actions?.updateCart) return; // native form post fallback
    event.preventDefault();
    if (this.busy) return;
    const variantId = String(new FormData(this.form).get('id') || '').trim();
    if (!variantId) return;

    this.busy = true;
    this.button.setAttribute('aria-busy', 'true');
    this.button.style.opacity = '0.6';
    try {
      const result = await window.Shopify.actions.updateCart(
        { lines: [{ merchandiseId: variantId, quantity: 1 }] },
        { event: { context: 'collection', detail: { source: 's-quick-add', productId: this.dataset.productId } } },
      );
      const errors = result?.errors || result?.userErrors;
      if (errors && errors.length) {
        if (this.status) this.status.textContent = errors[0].message || this.dataset.errorMessage || '';
      } else {
        if (this.status) this.status.textContent = this.dataset.addedMessage || '';
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.button.animate(
            [{ transform: 'scale(1)' }, { transform: 'scale(1.2)' }, { transform: 'scale(1)' }],
            { duration: 320, easing: 'ease-out' },
          );
        }
        await window.Shopify.actions.openCart?.();
      }
    } catch (error) {
      if (this.status) this.status.textContent = this.dataset.errorMessage || '';
    } finally {
      this.busy = false;
      this.button.removeAttribute('aria-busy');
      this.button.style.opacity = '';
    }
  }
}

if (!customElements.get('s-quick-add')) customElements.define('s-quick-add', SQuickAdd);
